<!--地图组件-->
<template>
  <div class="left_search">
    <div class="left_search_close" @click="closeTrackPlayTool()"><i class="el-icon-error"></i></div>
    <div class="left_search_put">
      <div class="left_search_item">
        <label class="left_search_title">人员</label>
        <el-select v-model="search.entity" placeholder="请选择作业人员" size="mini" text-color="#ffffff">
          <el-option
              v-for="item in workers"
              :key="item.value"
              :label="item.label"
              :value="item"
          />
        </el-select>
      </div>
      <div class="left_search_item">
        <label class="left_search_title">记录时间</label>
        <el-date-picker
            v-model="search.time"
            type="datetimerange"
            size="mini"
            range-separator="-"
            start-placeholder="开始日期时间"
            end-placeholder="结束日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
        />
      </div>
      <div class="left_search_item">
        <el-button type="primary" icon="el-icon-search" :disabled="state!=1" size="mini" @click="searchHistory()">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini">重置</el-button>
      </div>
    </div>
    <div class="left_search_put">
      <div class="left_search_item">
        <label class="left_search_title">播放视角</label>
        <el-select v-model="search.viewType" placeholder="请选择播放视角" size="mini" text-color="#ffffff">
          <el-option
              v-for="item in viewTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          />
        </el-select>
      </div>
      <div class="left_search_item">
        <label class="left_search_title">播放速度</label>
        <el-radio-group v-model="search.speed">
          <el-radio :label="1">X1</el-radio>
          <el-radio :label="10">X10</el-radio>
          <el-radio :label="20">X20</el-radio>
          <el-radio :label="50">X50</el-radio>
          <el-radio :label="100">X100</el-radio>
        </el-radio-group>
      </div>

      <div class="left_search_item">
        <el-checkbox v-model="isShowTrack">显示历史轨迹</el-checkbox>
      </div>
    </div>
    <div class="left_search_put">
      <div class="left_search_item">
        <label class="left_search_title">播放控件</label>
        <el-button type="success" icon="el-icon-video-play" :disabled="state==2" size="mini" @click="playTrack">播放</el-button>
        <el-button type="success" icon="el-icon-video-pause" :disabled="state==3" size="mini" @click="pauseTrack">暂停</el-button>
        <el-button type="success" icon="el-icon-refresh-right" size="mini" @click="stopTrack">结束</el-button>
      </div>
    </div>
    <div class="left_search_put">
      <div class="left_search_item">
        <label class="left_search_title">播放进度</label>
        <el-slider v-model="progressValue" style="width: 800px" :marks="marks"></el-slider>
      </div>
    </div>
  </div>
</template>
<script>
import CONSTANTS from "./constants";
import MapUtil from './utils/mapUtil';
import * as Api from "@/api/api";
import TrackPlayTool from "./utils/TrackPlayTool";
import moment from "moment";
export default {
  name: 'trackPlayControl',
  data(){
    return {
      isShowTrack:true,
      search:{
        time: [moment().subtract(2, 'hours').format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')],
        speed:1,
        viewType:3,//TODO:播放视角
        entity:null,
      },
      viewTypes:[
          {label: '第一人称',value: 0},
          {label: '第三人称',value: 1},
          {label: '跟踪视角',value: 2},
          {label: '自由视角',value: 3},
      ],//TODO:播放视角类型
      workers:[],
      historyPoints:[],
      state:1,//TODO 1=查询与结束，2=播放，3=暂停，
      progressValue:0,//TODO 进度值
      marks: {
        0: '0%',
        10: '10%',
        20: '20%',
        30: '30%',
        40: '40%',
        50: '50%',
        60: '60%',
        70: '70%',
        80: '80%',
        90: '90%',
        100: '100%'
      }
    }
  },
  props:{
    tileSet: {
      type: Object,
      default: {}
    },
  },
  mounted(){
    let self=this;
    let workerLayer=MapUtil.getLayerByName(CONSTANTS.LAYER.WORKER);
    if(workerLayer){
      Api.getTxzkCards().then(res=>{
        if(res.data.code==200){
          res.data.data.map(item=>{
            if(item.eamEntity){
              self.workers.push({
                label:item.eamEntity.entityName+"["+item.cardAddr+"]",
                value:item.eamEntity.entityId
              })
            }
          })
          self.search.entity=self.workers.length>0? self.workers[0]:{};
        }
      })
    }
  },
  methods:{
    /**
     * TODO:切换轨迹播放工具面板
     */
    closeTrackPlayTool() {
      this.stopTrack();
      this.EventCenter.emit(CONSTANTS.EVENTS.TRACKPLAY, {});
    },
    /**
     * TODO:搜索历史轨迹
     */
    searchHistory() {
      let self=this;
      self.state=1;
      self.progressValue=0;
      Api.getTXZKWorkerHistory({entityId:this.search.entity.value,...this.search}).then((res)=>{
        let points=[];
        Object.values(res.data.data).map(item=>{
          if(item.length>0){
            if(item[0].x>0&&item[0].y>0){
              points.push(item[0])
            }
          }
        })
        if(points.length>0){
          self.points=points;
          self.initTrackPlayTool();
        }
      })
    },
    /**
     * TODO:初始化工具
     */
    initTrackPlayTool(){
      let self=this;
      if(self.trackPlayTool){
        self.trackPlayTool.stop();
        self.trackPlayTool=null;
      }
      //透明模型
      self.tileSet.style=new Cesium.Cesium3DTileStyle({color: "color('rgba(255,255,255,0.6)')"});
      this.trackPlayTool=new TrackPlayTool(viewer, {
        points:self.points,
        image:require('../img/map/user0.png'),
        name:self.search.entity.label,
        speed:self.search.speed,//速度
        viewType: self.search.viewType,//TODO:视角
        showTrack:self.isShowTrack,
        callback:(position,progress)=>{//Todo 回调：当前点与进度
          self.progressValue=progress*100;
        }
      });
    },
    /**
     * TODO:播放历史轨迹
     */
    playTrack(){
      this.initTrackPlayTool();
      this.trackPlayTool.play();//Todo:播放
      this.state=2;
      this.progressValue=0;
    },
    pauseTrack(){
      if(this.trackPlayTool) {
        this.trackPlayTool.pause();
      }
      this.state=3;
    },
    stopTrack(){
      if(this.trackPlayTool) {
        this.trackPlayTool.stop();
        this.trackPlayTool=null;
      }
      this.state=1;
      this.$parent.initView();
      //透明模型
      this.tileSet.style=new Cesium.Cesium3DTileStyle({color: "color('rgba(255,255,255,1)')"});
    }

  },
  beforeDestroy() {
    this.stopTrack();

  }
}
</script>
<style lang="less">
  .left_search{
    position: absolute;
    z-index: 999;
    left: 390px;
    top: 100px;
    background: rgba(6,28,50,.7);
    border: 1px solid rgba(0,153,255,.4);
    border-radius: 2px;
    box-shadow: 5px 5px 25px rgb(0 0 0 / 40%);
    width: 916px;
    padding: 10px;
    .left_search_put{
      display: flex;
      margin: 20px 0;
      .left_search_item{
        display: flex;
        margin-right: 10px;
        flex-shrink: 0;
        .left_search_title{
          width: 65px;
          line-height: 28px;
        }
        .el-button--mini{
          height: 28px;
          line-height: 28px;
          padding: 0 10px;
        }
        .el-checkbox{
          color: #fff!important;
          line-height: 28px!important;
        }
        .el-radio{
          color: #fff!important;
          line-height: 28px!important;
        }
      }
    }
    .left_search_close{
      position: absolute;
      right: 2px;
      top: 2px;
      .el-icon-error{
        font-size: 20px!important;
      }
    }
  }
</style>
